<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Debtors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      title: "Debtors",
      items: [
        {
          text: "Accounts Section",
          href: "#/",
        },
        {
          text: "Debtors",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient_number",
          sortable: true,
          label: "NUMBER",
        },
        {
          key: "cost",
          sortable: true,
          label: "TOTAL AMOUNT",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance_field",
          sortable: true,
          label: "BALANCE",
        },
        {
          sortable: false,
          key: "invoice_field",
          label: "INVOICE",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // CLOSE VISIT
      close_debtor: {
        balance: "",
        patient_name: "",
        visit_id: "",
      },
      // END CLOSE VISIT
        edit_debt: {
            balance: "",
            new_balance: "",
            patient_name: "",
            visit_id: "",
        },
      // VALIDATION
      validatorState: {
        mode_type: "",
        balance: "",
        transdate: "",
        duedate: "",
        name: "",
        address: "",
        contact: "",
        discount: "",
      },
      // CLEAR BALANCE
      clear_balance: {
        mode_type: "",
        paid: "",
        balance: "",
        received: "",
        total: "",
        index: "",
        pay_id: "",
        patient_name: "",
        transdate: "",
      },
        clear_date_message:"",
        clear_amount_message:"",
        clear_mode_message:"",
      // END CLEAR BALANCE

      // GENERATE INVOICE
      invoice: {
        debtor: "",
        pay_id: "",
        address: "",
        contact: "",
        balance: "",
        due_date: "",
      },
      // END GENERATE INVOICE
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapState("payments", ["print_reciept"]),
    ...mapGetters("payments", [
      "Debtors",
      "invoiceGenerateStatus",
      "PaymentModes",
      "ClearStatus",
    ]),
    ...mapGetters("auth", ["user_permissions"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.Debtors ? this.Debtors.length : 1;
    },
    /**
     * Todo list of records
     */
  },
  watch: {
    print_reciept(newValue) {
      if (newValue == true) {
        window.open(
          `https://${window.location.host}/preciept?id=${btoa(this.clear_balance.pay_id)}`
        );
        //  this.$router.push(
        //         `pay_reciept/${btoa(this.clear_balance.pay_id)}/${btoa(
        //           this.clear_balance.balance
        //         )}`
        //       );
      }
    },
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Debtors ? this.Debtors.length : 1;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    yes(dd) {
      alert(dd);
    },
    ...mapActions({
      FetchDebtors: "payments/fetchDebtors",
      CloseDebtorMethod: "payments/closeDebtor",
      EditDebtMethod: "payments/editDebtor",
      FetchPaymentModes: "payments/fetchPaymentModes",
      ClearBalance: "payments/clearBalance",
      GenerateInvoice: "payments/generateInvoice",
    }),

    // COMMA SEPARATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    // CLEAR BALANCE
    clear_model(data) {
      this.$store.commit("payments/PAYMENT_RECIEPT_EMPTY"),
        (this.clear_balance.balance = data.balance),
        (this.clear_balance.paid = data.paid),
        (this.clear_balance.total = data.cost),
        (this.clear_balance.transdate = this.current_date),
        (this.clear_balance.patient_name = data.patient_name),
        (this.clear_balance.pay_id = data.pay_id);
    },
    // END CLEAR BALANCE
    // '
    // GENERATE INVOICE
    generate_Invoice(data, modelId) {
      (this.model_id = modelId),
        (this.invoice.debtor = data.patient_name),
        (this.invoice.pay_id = data.pay_id),
        (this.invoice.address = data.patient_address),
        (this.invoice.contact = data.patient_contact),
        (this.invoice.balance = data.balance);
      this.invoice.due_date = "";
    },
    // CLOSE VISIT
    close_debtor_model(data, index) {
      (this.close_debtor.balance = data.balance),
        (this.close_debtor.patient_name = data.patient_name);
      this.close_debtor.visit_id = data.visit_id;
      this.close_debtor.index = index;
    },
    CloseDebtor() {
      let payload = {
        patient_name: this.close_debtor.patient_name,
        visit_id: this.close_debtor.visit_id,
        balance: this.close_debtor.balance,
      };

      this.CloseDebtorMethod(payload);
      this.closeMode("modal-close_debtor");
      this.$store.commit("payments/REMOVE_DEBTOR_OBJECT", this.close_debtor.index);
    },
    // END CLOSE VISIT

      edit_debt_model(data, index) {
          this.edit_debt.balance = data.balance;
          this.edit_debt.new_balance = data.cost.replace(',', '');
          this.edit_debt.patient_name = data.patient_name;
          this.edit_debt.visit_id = data.visit_id;
          this.edit_debt.index = index;
      },
      EditDebt(model) {
          let payload = {
              patient_name: this.edit_debt.patient_name,
              visit_id: this.edit_debt.visit_id,
              balance: this.edit_debt.balance,
              new_balance: this.edit_debt.new_balance,
          };

          this.EditDebtMethod(payload);
          this.closeMode(model);
      },

    // VALIDATION
    checkInvoiceValidity() {
      const valid = this.$refs.form.checkValidity();
      (this.validatorState.name = valid);
          (this.validatorState.balance = valid);
          (this.validatorState.duedate = valid);
      this.validatorState.address = valid;
      this.validatorState.contact = valid;
      return valid;
    },

    resetModal() {
        this.clear_balance.received="";
        this.clear_balance.mode_type="";
    },
    handleInvoiceSubmit() {
      // Exit when the form isn't valid
      if (!this.checkInvoiceValidity()) {
        return;
      }
      this.GenerateInvoice(this.invoice);
    },
    handleSubmit(modal_id) {
        this.model_id=modal_id;
        if (!this.clear_balance.transdate){
            this.clear_date_message='Transaction date';
            return;
        }else {
            this.clear_date_message='';
        }
        if (!this.clear_balance.received || this.clear_balance.received < 1){
            this.clear_amount_message='Amount paid is required';
            return;
        }else {
            this.clear_amount_message='';
        }
        if (this.clear_balance.received > this.clear_balance.balance){
            this.clear_amount_message='Amount paid is not valid - more than expected';
            return;
        }else {
            this.clear_amount_message='';
        }
        if (!this.clear_balance.mode_type){
            this.clear_mode_message='Select payment mode';
            return;
        }else {
            this.clear_mode_message='';
        }
      this.ClearBalance(this.clear_balance);
    },

    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
  },
  created() {
    this.FetchDebtors();
    this.FetchPaymentModes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="mb-3">
                <router-link
                  :to="{
                    name: 'BadDebtors',
                  }"
                >
                  <button align="right" class="btn btn-info btn-sm float-end">
                    <i class="fa fa-eye"></i> Bad Debtors
                  </button>
                </router-link>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Debtors ? Debtors : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(balance_field)="data">
                  {{ thousandSeprator(data.item.balance) }}
                  <button
                    v-if="
                      data.item.balance > 0 &&
                      data.item.invoice == 0 &&
                      user_permissions.clear_payments
                    "
                    v-b-modal.modal-clear
                    class="btn btn-success m-2 btn-sm"
                    @click="clear_model(data.item)"
                  >
                    Pay now
                  </button>
                  <button
                    v-else-if="
                      data.item.balance > 0 &&
                      data.item.invoice != 0 &&
                      user_permissions.clear_payments
                    "
                    v-b-modal.modal-clear
                    class="btn btn-primary m-2 btn-sm"
                    @click="clear_model(data.item)"
                  >
                    Pay now
                  </button>
                </template>
                <template #cell(invoice_field)="data">
                    <span v-if="data.item.invoice != 0 && user_permissions.view_invoice">
                        <router-link :to="{name: 'PatientInvoiceDetails', params: { invoice_id: data.item.invoice }}">
                          <button class="btn btn-outline-info btn-sm"><i class="fa fa-eye"></i> Invoice</button>
                        </router-link>
                    </span>
                    <span v-else-if="data.item.invoice == 0 && user_permissions.generate_invoice">
                        <button v-b-modal.generate_invoice class="btn btn-primary btn-sm" @click="generate_Invoice(data.item, 'generate_invoice')">
                          <i class="fa fa-plus fa-spin"></i> Generate
                        </button>
                    </span>
                    <span v-else>
                        <button disabled class="btn btn-primary btn-sm">
                          <i class="fa fa-ban"></i> Invoice
                        </button>
                    </span>
                </template>
                <template #cell(actions)="data">
                  <button
                    v-if="user_permissions.close_debtors"
                    v-b-modal.modal-close_debtor
                    class="btn btn-danger btn-sm"
                    @click="close_debtor_model(data.item)"
                  >
                    Close Debtor
                  </button>
                  <button v-else disabled class="btn btn-danger btn-sm">
                    <i class="fa fa-ban"></i> Close Debtor
                  </button>

                    <button
                            v-if="user_permissions.close_debtors"
                            v-b-modal.modal_edit_debt
                            class="btn btn-secondary btn-sm ms-2"
                            @click="edit_debt_model(data.item)"
                    >
                        Edit Debt
                    </button>
                    <button v-else disabled class="btn btn-secondary btn-sm ms-2">
                        <i class="fa fa-ban"></i> Edit Debt
                    </button>
                </template>
              </b-table>
              <div style="text-align: center">
                <h3 v-if="!Debtors" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- CLOSE DEBTOR MODEL -->
            <b-modal
              id="modal-close_debtor"
              size="sm"
              :title="'Close ' + this.close_debtor.patient_name + ' Visit'"
              title-class="font-18"
              hide-footer
            >
              <p v-if="close_debtor.balance > 0" class="text-danger">
                Are you sure you want to close <b>{{ this.close_debtor.patient_name }}</b
                >'s visit with a balance of <b>{{ this.close_debtor.balance }}</b>
              </p>
              <p v-else class="text-danger">
                Are you sure you want to close <b>{{ this.close_debtor.patient_name }}</b
                >'s visit
              </p>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary float-start"
                  @click="closeMode('modal-close_debtor')"
                >
                  cancel
                </button>
                <button type="submit" @click="CloseDebtor()" class="btn btn-success">
                  close visit
                </button>
              </div>
            </b-modal>
              <!-- END CLOSE DEBTOR MODEL -->

              <!-- EDIT DEBT MODEL -->
              <b-modal id="modal_edit_debt" size="sm" :title="'update ' + this.edit_debt.patient_name + ' debt'" title-class="font-18" hide-footer>
                  <p class="text-danger">
                      Are you sure you want to edit <b>{{ this.edit_debt.patient_name }}</b>'s visit debt of <b>{{ this.edit_debt.balance }}</b>
                  </p>
                  Change the total bill in the field below to affect the balance.
                  <input class="form-control" v-model="edit_debt.new_balance"/>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary float-start" @click="closeMode('modal_edit_debt')">
                          cancel
                      </button>
                      <button type="submit" @click="EditDebt('modal_edit_debt')" class="btn btn-success">
                          Update Debt
                      </button>
                  </div>
              </b-modal>
            <!-- END EDIT DEBT MODEL -->

            <!-- GENERATE INVOICE MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="generate_invoice"
                    :title="'Generate Invoice for ' + invoice.debtor"
                    title-class="font-18"
                    @show="resetModal"
                    @hidden="resetModal"
                    hide-footer
                  >
                    <form ref="form" @submit.stop.prevent="handleInvoiceSubmit">
                      <b-form-group
                        label="NAME"
                        label-for="date-input"
                        invalid-feedback="Transaction date is required"
                        :state="validatorState.name"
                      >
                        <b-form-input
                          type="text"
                          id="name-input"
                          v-model="invoice.debtor"
                          :state="validatorState.name"
                          required
                        ></b-form-input>
                      </b-form-group>
                      <b-form-group
                        label="Address"
                        label-for="date-input"
                        invalid-feedback="Please enter address"
                        :state="validatorState.address"
                      >
                        <b-form-input
                          placeholder="Enter Address"
                          id="name-input"
                          v-model="invoice.address"
                          :state="validatorState.address"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="CONTACT"
                        label-for="date-input"
                        invalid-feedback="Please enter contact"
                        :state="validatorState.contact"
                      >
                        <b-form-input
                          placeholder="Enter contact"
                          id="name-input"
                          v-model="invoice.contact"
                          :state="validatorState.contact"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Balance"
                        label-for="date-input"
                        invalid-feedback="Please enter amount"
                        :state="validatorState.balance"
                      >
                        <b-form-input
                          placeholder="Enter balance"
                          id="name-input"
                          v-model="invoice.balance"
                          :state="validatorState.balance"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <b-form-group
                        label="Due Date"
                        label-for="date-input"
                        invalid-feedback="Please enter due date"
                        :state="validatorState.duedate"
                      >
                        <b-form-input
                          type="date"
                          id="name-input"
                          v-model="invoice.due_date"
                          :state="validatorState.duedate"
                          required
                        ></b-form-input>
                      </b-form-group>

                      <div class="modal-footer">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="closeMode('generate_invoice')"
                        >
                          Close
                        </button>
                        <button type="submit" class="btn btn-primary">
                          Generate
                          <b-spinner
                            v-if="invoiceGenerateStatus"
                            class="m-0"
                            variant="light"
                            small
                            role="status"
                          ></b-spinner>
                        </button>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END GENERATE INVOICE MODEL -->

            <!-- CLEAR BALANCE MODEL -->
            <div class="row">
              <div class="col-sm-6 col-md-4 col-xl-3">
                <div class="my-4 text-center">
                  <b-modal
                    id="modal-clear"
                    :title="'Clear balance for ' + clear_balance.patient_name"
                    title-class="font-18"
                    @show="resetModal"
                    @hidden="resetModal"
                    hide-footer>
                    <div>
                        <div class="mb-3">
                            <label for="date" class="form-label">Transaction Date*</label>
                            <input type="date" class="form-control" v-model="clear_balance.transdate" id="date" placeholder="Transaction Date">
                            <i v-if="clear_date_message" class="text-danger">{{clear_date_message}}</i>
                        </div>

                        <div class="mb-3">
                            <label for="received" class="form-label">Amount paid* (Bal: {{ clear_balance.balance }})</label>
                            <input type="number" min="1" class="form-control" required v-model="clear_balance.received" id="received" placeholder="Enter amount paid here">
                            <i v-if="clear_amount_message" class="text-danger">{{clear_amount_message}}</i>
                        </div>

                        <div class="mb-3">
                            <label for="mode" class="form-label">Payment mode*</label>
                            <select class="form-control" required v-model="clear_balance.mode_type" id="mode">
                                <option value="">Select Payment mode</option>
                                <option v-for="(mode, m) in PaymentModes" :key="m" :value="mode.id">{{ mode.mode }}</option>
                            </select>
                            <i v-if="clear_mode_message" class="text-danger">{{clear_mode_message}}</i>
                        </div>

                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeMode('modal-clear')">
                          Close
                        </button>
                        <button type="button" class="btn btn-primary" @click="handleSubmit('modal-clear')">
                          Clear
                          <b-spinner
                            v-show="ClearStatus"
                            style="float: right"
                            class="m-0"
                            small
                            variant="light"
                            role="status"
                          ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- END CLEAR BALANCE MODEL -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
